export var EKindOfFilter;
(function (EKindOfFilter) {
    EKindOfFilter["DROPDOWN"] = "Dropdown";
    EKindOfFilter["TEXT_INPUT"] = "TextInput";
})(EKindOfFilter || (EKindOfFilter = {}));
export const NumberFilterKeys = {
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN: "LESS_THAN"
};
